<div class="empty-state-container">
  @let config = emptyConfig();
  @if (config && config.emptyTitle) {
    <p class="empty-state-title">{{ config.emptyTitle | translate }}</p>
  }

  @if (config && config.emptySubTitle) {
    <p [innerHTML]="config.emptySubTitle | translate"></p>
  }

  @if (showButton() && config && config.emptyButton) {
    <app-general-button
      [buttonStyle]="'primary'"
      [buttonHeight]="32"
      [buttonName]="config?.emptyButton || ''"
      [iconStart]="config && !config.emptyButtonIconLeft ? config.emptyButtonIcon : ''"
      [iconEnd]="config && config.emptyButtonIconLeft ? config.emptyButtonIcon : ''"
      (buttonClicked)="buttonClickedEvent.emit()"
    />
  }
</div>
